import { defineComponent as _defineComponent } from 'vue'
import VFooter from "@/components/vFooter.vue";
import {useTranslations} from "@/hooks/useTranslations";
import {useRoute} from "vue-router/composables";
import {MarketingParams} from "@/models/Subscriptions/MarketingParams";
import {onMounted, ref} from "vue";
import {useStore} from "@/hooks/useStore";
import {TRANSLATIONS_FETCH} from "@/store/ActionTypes";
import FreeTrialSignupForm from "@/components/forms/Signup/FreeTrialSignupForm.vue";
import {useNotify} from "@/hooks/useNotify";


export default /*#__PURE__*/_defineComponent({
  __name: 'FreeTrialSignup',
  setup(__props) {

const translations = useTranslations();
const route = useRoute();
const store = useStore();
const notify = useNotify();

const marketingParams = ref<MarketingParams>({
  source: '',
  medium: '',
  campaign: '',
  term: '',
  gclid: '',
});

onMounted(async() => {
  await getUtmTags();
  await store.value.dispatch(TRANSLATIONS_FETCH, {
    category: "pages",
    collections: [
      "common",
      "login",
      "customers",
      "managesubscription",
      "profile",
    ],
  });
});

async function getUtmTags() {
  const query = route.query;

  marketingParams.value.source = (query.utm_source as string) || '';
  marketingParams.value.medium = (query.utm_medium as string) || '';
  marketingParams.value.campaign = (query.utm_campaign as string) || '';
  marketingParams.value.term = (query.utm_term as string) || '';
  marketingParams.value.gclid = (query.gclid as string) || '';
}

return { __sfc: true,translations, route, store, notify, marketingParams, getUtmTags, VFooter, FreeTrialSignupForm }
}

})